module.exports = __webpack_public_path__ + "img/scienceBorder_left.853eabc6.png";